var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('v-select',{attrs:{"items":_vm.items,"label":"Currency","item-text":"currency","item-value":"id","rules":_vm.rules},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }